export function getElementByClassName(className: string, index: number): HTMLElement {
  return (document.getElementsByClassName(className)[index] as HTMLElement);
}
